import React, { useState } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    Avatar,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const DeleteProject = ({ open, onClose }) => {

    const [options, setOptions] = useState({
        deleteProject: true,
    });

    const toggleOption = (key) => {
        setOptions((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm" >
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0', }}>

                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1' , fontFamily:'Manrope'}}>Delete project</Typography>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box display="flex" alignItems="center" sx={{ gap: '8px' }}>
                        <Avatar sx={{ height: '42px', width: '42px', fontSize: '14px', backgroundColor: '#5932EA', color: '#fff', fontFamily:'Manrope' }}>
                            <span>SG</span>
                            {/* <img src="./assets/images/insights/file/project-icon.svg" alt='project icon' style={{
                                    height: '42px', width: '42px',
                                    backgroundSize: 'cover', objectFit: 'cover' className="img-fluid" /> */}
                        </Avatar>
                        <Box>
                            <Typography fontSize={'16px'} fontWeight={'600'} sx={{ lineHeight: '1', fontFamily:'Manrope' }}>Sky Grid</Typography>
                            <Typography fontSize={'14px'} color='#64748B' fontWeight={'400'} sx={{fontFamily:'Manrope'}}>Worked Desk 1</Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#373737', margin: '16px auto 0', fontFamily:'Manrope' }}>By deleting this project, you will lose the following information:</Typography>
                        <ul style={{ fontSize: '14px', fontWeight: '400', color: '#373737', listStyle: 'inside', marginLeft: '6px', fontFamily:'Manrope' }}>
                            <li>The project and all time tracked to it</li>
                            <li>The to-dos inside the project and time tracked to them</li>
                        </ul>
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#373737', margin: '12px auto', fontFamily:'Manrope' }}>Keep in mind that reports will no longer show this project, but you will still see payment records for approved time tracked on this project.</Typography>
                        <Typography display="flex" alignItems="center" sx={{ fontSize: '14px', fontWeight: '400', color: '#373737', gap: '8px', margin: '0px auto 12px', fontFamily:'Manrope' }}>
                            <Tooltip title="This can't be undone" arrow placement="top">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" sx={{ fontSize: '16px', color: '#F4413D' }} />
                                </button>
                            </Tooltip>
                            This can't be undone</Typography>

                        <ul className="space-y-3">
                            <li className="cursor-pointer" style={{ margin: '6px auto', fontFamily:'Manrope' }} onClick={() => toggleOption('deleteProject')}>
                                <input type="checkbox" checked={options.deleteProject} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                                <span style={{ fontSize: '14px', fontWeight: '400', color: '#373737', lineHeight: '2' }}>I understand and wish to delete this project</span>
                            </li>
                        </ul>
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px', borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily:'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#F4413D', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #F4413D', fontFamily:'Manrope' }}>
                        Delete
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default DeleteProject;
